<template>
  <div id="addStore">
    <div class="top clearfix">
      <i class="el-icon-menu"></i>
      <div class="msgTitle">添加商品</div>
      <div class="button">
        <el-button class="excelBtn" type="primary" @click="addGoods">保存</el-button>
      </div>
    </div>
    <div class="containertMain">
      <div class="container1">
        <el-form ref="form" label-width="100px">
          <div class="Modular1">
            <div class="title">基本信息</div>
            <div class="content">
              <el-row>
                <el-form-item label="*商品主图" class="upload">
                  <ul class="imagesList">
                    <li class="imagesItem" v-for="(item, index) in imagesList" :key="index">
                      <img class="img" :src="item" alt width="100%" height="100%" />
                      <img
                        class="del"
                        src="../../assets/images/fail.png"
                        alt
                        @click="delImages(index)"
                      />
                    </li>
                  </ul>
                  <div @click="handleUploadImages(1)" class="picture">
                    <img src="../../assets/images/addImages.png" alt width="100%" height="100%" />
                  </div>
                </el-form-item>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="*商品名称">
                    <el-input placeholder="请输入商品名称" class="inputItem" v-model="goodsName"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="*商品分类">
                    <!-- <el-input placeholder="上架" class="inputItem" v-model="status"></el-input> -->
                    <el-select
                      class="inputItem"
                      v-model="type"
                      placeholder="请选择"
                      @change="changeStatu($event)"
                    >
                      <el-option
                        v-for="item in goodsCategory"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="商品促销语">
                    <el-input
                      class="inputItem"
                      v-model="saleDesc"
                      placeholder="请输入，最多100字符"
                      maxlength="100"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="原价(元)">
                    <el-input
                      class="inputItem"
                      v-model="oldPrice"
                      placeholder="请输入商品价格"
                      oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"
                      maxlength="11"
                    ></el-input>
                    <div class="textColor">原价仅作为价格对比展示，不按此价格进行销售</div>
                  </el-form-item>
                </el-col>

                <el-col :span="12">
                  <el-form-item label="*成本">
                    <el-input
                      placeholder="请输入，最大999,999,999"
                      class="inputItem"
                      v-model="costPrice"
                      oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"
                      maxlength="11"
                    ></el-input>
                    <div class="textColor">不展示在商城内，尽量填写完整，有助于商品销售的数据分析</div>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="*销售价(元)">
                    <el-input
                      class="inputItem"
                      v-model="price"
                      placeholder="请输入商品价格"
                      oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"
                      maxlength="11"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="园区币价">
                    <el-input
                      class="inputItem"
                      v-model="gardenPrice"
                      placeholder="请输入园区币价格"
                      oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"
                      maxlength="11"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="*商品库存">
                    <el-input
                      placeholder="请输入"
                      class="inputItem"
                      v-model="stacks"
                      oninput="value=value.replace(/[^\d]/g,'')"
                      maxlength="11"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="预警库存">
                    <el-input
                      class="inputItem"
                      v-model="warningRepertory"
                      placeholder="请输入，库存不足进行提醒"
                      oninput="value=value.replace(/[^\d]/g,'')"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="商品类型">
                    <el-checkbox-group v-model="checkType" class="check">
                      <el-checkbox
                        v-for="(item,index) in checkTypeList"
                        :label="item.id"
                        :key="index"
                        @change="handleCheckedTypesChange(item.id)"
                      >{{item.name}}</el-checkbox>
                    </el-checkbox-group>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="商品条形码">
                    <el-input
                      class="inputItem"
                      v-model="barCode"
                      placeholder="请输入商品条形码"
                      oninput="value=value.replace(/[^\d]/g,'')"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="Modular1">
            <div class="title">设置</div>
            <div class="content">
              <el-row>
                <el-col :span="12">
                  <!-- <el-form-item class='check'> -->
                  <el-checkbox-group v-model="checkList" class="check">
                    <el-checkbox
                      v-for="(item,index) in checkBoxList"
                      :label="item.id"
                      :key="index"
                      @change="handleCheckedCitiesChange(item.id)"
                    >{{item.name}}</el-checkbox>
                  </el-checkbox-group>
                  <!-- </el-form-item> -->
                </el-col>
              </el-row>
              <div class="presellSet" v-show="status === -1">
                <div class="set">预售设置(预售为全款预售，预售商品不支持加入购物车)</div>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="预售价格(元)">
                      <el-input
                        class="inputItem"
                        v-model="presalePrice"
                        placeholder="请输入，最大999,999,999"
                        maxlength="100"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="预售说明">
                      <el-input
                        class="inputItem"
                        v-model="presaleMark"
                        placeholder="最多30字"
                        maxlength="30"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="预售结束时间">
                      <el-date-picker
                        class="endDate"
                        v-model="endTime"
                        type="datetime"
                        :picker-options="expireTimeOption"
                        placeholder="选择日期"
                      ></el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <div class="num">预售结束后，商品下架</div>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="已预定量">
                      <div class="endNum">
                        当预售结束后，已预定量少于
                        <el-input
                          placeholder="请输入，最大999"
                          class="inputItem30"
                          v-model="minCount"
                          oninput="value=value.replace(/[^\d]/g,'')"
                          maxlength="11"
                        ></el-input>进行提醒
                      </div>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="发货时间">
                      <el-radio-group v-model="preRedio" @change="changeRedio">
                        <el-radio class="blex1" label="0">
                          <el-select
                            v-model="sendType"
                            placeholder="请选择"
                            :disabled="preRedio!=='0'"
                          >
                            <el-option
                              v-for="item in dateOptions"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            ></el-option>
                          </el-select>
                          <el-input
                            placeholder="请输入，最大999"
                            class="inputItem30"
                            v-model="date1"
                            :disabled="preRedio!=='0'"
                            oninput="value=value.replace(/[^\d]/g,'')"
                            maxlength="11"
                          ></el-input>天之内
                        </el-radio>
                        <el-radio class="blex2" label="1">
                          <el-date-picker
                            class="startDate"
                            v-model="date2"
                            type="date"
                            :picker-options="expireTimeOption"
                            :disabled="preRedio=='0'"
                            placeholder="选择日期"
                          ></el-date-picker>开始发货
                        </el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
            </div>
          </div>
          <div class="Modular1" v-if="status == 0 || status == 1">
            <div class="title">
              商品关联
              <span class="title_">商品关联成功后，可在商城内的本商品详情内快速查看或购买其关联商品。商品属性用于区分各关联商品。</span>
            </div>
            <div class="content">
              <div class="shuxing">
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="本商品属性" :required="true">
                      <el-input v-model="propertyName"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row v-for="(item,index) in relatedGoods" :key="index">
                  <el-col :span="11">
                    <el-form-item label="属性" :required="true">
                      <el-input v-model="item.name"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="11">
                    <el-form-item label="关联商品" :required="true">
                      <el-input v-model="item.goodName">
                        <el-button slot="append" @click="selectProducts(index)">选择商品</el-button>
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="2">
                    <el-button
                      type="text"
                      style="width:80%;margin-left:20%;color:red;"
                      @click="delRelated(index)"
                    >删除</el-button>
                  </el-col>
                </el-row>
                <el-form-item>
                  <el-button type="primary" @click="addRelated" style="width:150px;">添加</el-button>
                  <el-button
                    type="primary"
                    style="width:150px;"
                    @click="dialogVisible = true"
                  >新增商品并关联</el-button>
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="Modular2">
            <div class="title">商品介绍</div>
            <div class="content">
              <el-row>
                <el-col :span="12">
                  <el-form-item label="规格">
                    <el-input placeholder="例如：一箱" v-model="specification"></el-input>
                  </el-form-item>
                </el-col>
                <!--  -->
                <el-col :span="12">
                  <el-form-item label="重量">
                    <el-input placeholder="不限" class="inputItem" v-model="weight"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="保质期">
                    <el-input placeholder="请输入保质期" class="inputItem" v-model="lifeTime"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="产地">
                    <el-input
                      placeholder="最长8个字符"
                      maxlength="8"
                      class="inputItem"
                      v-model="product"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <!-- <el-row>
                <el-col :span="12">
                  <el-form-item label="限购(件)">
                    <el-input placeholder="不限" class="inputItem" v-model="limit"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="商品溯源">
                    <el-select @change="changezhou($event)" class="inputItem" v-model="suyuan" placeholder="请选择">
                      <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                    <div style="color:#1591CF;cursor:pointer" @click="go">编辑溯源信息</div>
                  </el-form-item>
                </el-col>
              </el-row>-->
              <el-row>
                <el-form-item label="商品描述">
                  <div style="text-align:left">
                    <div ref="toolbar" class="toolbar">
                      <div
                        class="el-icon-picture w-e-icon-image uploadimg"
                        @click="handleUploadImages(2)"
                      ></div>
                    </div>
                    <div ref="editor" class="editor"></div>
                  </div>
                </el-form-item>
              </el-row>
            </div>
          </div>
        </el-form>
      </div>
    </div>
    <el-dialog title="选择商品" :visible.sync="centerDialogVisible" width="60%" center>
      <div style="margin:20px 0;">
        <el-input
          style="width:300px;"
          placeholder="请输入商品名称\编码"
          maxlength="30"
          v-model="searchValue"
        ></el-input>
        <el-button type="primary" @click="getGoodList(1)">搜索</el-button>
        <el-button type="info" @click="reset">重置</el-button>
      </div>
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column align="center" prop="goodName" label="商品名称"></el-table-column>
        <el-table-column align="center" prop="price" label="售价" width="180"></el-table-column>
        <el-table-column align="center" prop="stock" label="库存" width="180"></el-table-column>
        <el-table-column align="center" prop="address" label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="addsgood(scope.row)">选择商品</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @current-change="pageFn()"
        layout="prev, pager, next"
        :current-page.sync="currentPage"
        :page-size="10"
        :total="goodsCount"
      ></el-pagination>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="新增商品并关联" :visible.sync="dialogVisible" width="80%" center>
      <v-addgood @func='getValue'></v-addgood>
    </el-dialog>
  </div>
</template>
<script>
import fetch from "@/utils/fetch";
import vAddgood from "../../components/addGood.vue";
import {
  tradeGoods,
  getUploadToken,
  getUploadId,
  addGoods,
  getgoodsclassification,
  getGoodCategory,
  addPreGoods,
  getSeckillGood,
} from "@/api/goods";
import E from "wangeditor";
import A from "../../assets/upload";
// import editorBar from "./EditorBar";
import { mapGetters, mapActions } from "vuex";
const toolbarOptions = [
  ["bold", "italic", "underline", "strike"], // toggled buttons
  ["blockquote", "code-block"],

  [{ header: 1 }, { header: 2 }], // custom button values
  [{ list: "ordered" }, { list: "bullet" }],
  [{ script: "sub" }, { script: "super" }], // superscript/subscript
  [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
  [{ direction: "rtl" }], // text direction

  [{ size: ["small", false, "large", "huge"] }], // custom dropdown
  [{ header: [1, 2, 3, 4, 5, 6, false] }],

  [{ color: [] }, { background: [] }], // dropdown with defaults from theme
  [{ font: [] }],
  [{ align: [] }],
  ["link", "image", "video"],
  ["clean"], // remove formatting button
];
export default {
  mixins: [A],
  components: {
    vAddgood,
  },
  data() {
    const _this = this;
    return {
      dialogImageUrl: "",
      dialogVisible: false,
      fileList: [],
      goodsName: "", // 商品名称
      oldPrice: "", // 原价
      price: "", // 普通价
      specification: "",
      classify: "",
      status: 0, //是否预售
      gardenPrice: "", // 园区币
      impose: "",
      trace: "",
      product: "",
      form: [],
      limit: "",
      stacks: "",
      specification: "",
      categoryId: "", // 商品分类Id
      stockType: "",
      statusId: "",
      Image: "",
      classList: "",
      options: [
        {
          value: "1",
          label: "开启",
        },
        {
          value: "0",
          label: "关闭",
        },
      ],
      statusBox: [
        {
          value: "0",
          label: "在售",
        },
        {
          value: "1",
          label: "下架",
        },
        {
          value: "2",
          label: "删除",
        },
      ],
      checkTypeList: [
        { id: 2, name: "到店自取" },
        { id: 1, name: "园区配送" },
      ],
      checkBoxList: [
        { id: 0, name: "正常销售" },
        { id: -1, name: "商品预售" },
        { id: 1, name: "不上架" },
      ],
      radio: 1,
      warningRepertory: "", //库存最小值
      goodsTypeList: [
        // 商品类型列表
        {
          value: "0",
          label: "园区配送",
        },
        {
          value: "1",
          label: "快递邮寄",
        },
        {
          value: "2",
          label: "到点自取",
        },
      ],
      goodsCategory: [], // 商品分类列表
      suyuan: "",
      cos: {},
      content: "",
      editorOption: {
        modules: {
          toolbar: {
            container: toolbarOptions, // 工具栏
            handlers: {
              image: function (value) {
                if (value) {
                  // (handleUploadImage() {
                  let option = {
                    multiple: !1,
                    params: {
                      isupdate: 2,
                      region: "ap-beijing",
                      bucket: "range-smartpark-1257239906",
                      previewUrl: "https://cdn.shop.rangepark.cn",
                    },
                    getFileId: getUploadId,
                    getAuthFunction: getUploadToken,
                    accept: "image/*",
                  };
                  _this.handleClickUpload(option);
                  // })();
                } else {
                  this.quill.format("image", false);
                }
              },
            },
          },
        },
      },
      imagesList: [], // 完成上传图片展示列表
      type: 0, // 商品类型
      promotion: "", // 促销语
      period: "", // 保质期
      weight: "", // 重量
      saleDesc: "", // 促销语
      lifeTime: "", // 保质期
      barCode: "", // 条形码
      dateOptions: [
        {
          value: 1,
          label: "预售结束",
        },
        {
          value: 2,
          label: "支付成功",
        },
      ],
      preRedio: "0",
      selectValue: "",
      checkList: [0], // 选择设置类型
      checkType: [2],
      // 预售参数
      costPrice: "", //成本价
      endTime: "", // 预售结束时间
      presalePrice: "", //预售价格
      presaleMark: "", //预售说明
      minCount: "", // 最小预售量
      sendType: this.sendType, //发货类型
      sendTime: this.preRedio == "0" ? this.date1 : this.date2, //发货时间
      date1: "",
      date2: "",
      selectType: 2,
      expireTimeOption: {
        disabledDate(date) {
          return date.getTime() <= Date.now();
        },
      },
      relatedGoods: [], //关联商品列表
      searchValue: "", //添加关联商品列表搜索字段
      tableData: [], //添加关联商品列表
      centerDialogVisible: false,
      currentPage: 1,
      goodsCount: 10,
      selectIndex: 0,
      propertyName: "",
      dialogVisible: false,
    };
  },
  created() {
    this.getClass();
  },
  mounted() {
    this.$on("upload-finish", (data) => {
      let { isupdate } = data;
      // console.log(data);
      if (!data) return;
      if (isupdate == 2) {
        console.log(data);
        this.editor.cmd.do("insertImage", data.src);
      } else {
        if (this.imagesList.length > 4) {
          this.$message("最多上传5张图");
          return;
        }
        this.imagesList.push(data.src);
        this.imagesList = this.order2(this.imagesList);
      }
    });
    this._getGoodsCategory();
    this.seteditor();
  },
  computed: {
    ...mapGetters(["chooseCompany", "companyList", "mchId"]),
  },
  watch: {
    isClear(val) {
      // 触发清除文本域内容
      if (val) {
        this.info_ = null;
      }
    },
    content(value) {
      if (value !== this.editor.txt.html()) {
        // console.log(value);
        this.editor.txt.html(value);
      }
    },
    // value为编辑框输入的内容，这里我监听了一下值，当父组件调用得时候，如果给value赋值了，子组件将会显示父组件赋给的值
  },
  methods: {
    // 创建富文本实例
    seteditor() {
      this.editor = new E(this.$refs.toolbar, this.$refs.editor);
      // 配置菜单
      this.editor.customConfig.menus = [
        "bold", // 粗体
        // 'fontSize', // 字号
        "justify", // 对齐方式
        // 'fontName', // 字体
        "emoticon", // 表情
      ];
      this.editor.customConfig.showLinkImg = false;
      this.editor.customConfig.onchange = (html) => {
        let newStr = this.getImageFileId(html);
        let newWords = this.order(newStr);
        this.content = newWords;
        // console.log(this.content);
      };
      // 创建富文本编辑器
      this.editor.create();
    },
    handleUploadImages(index) {
      if (index == 1) {
        if (this.imagesList.length >= 5) {
          this.$message("最多上传5张图");
          return;
        }
      }
      let option = {
        multiple: !0,
        params: {
          isupdate: index,
          region: "ap-beijing",
          bucket: "range-smartpark-1257239906",
          previewUrl: "https://cdn.shop.rangepark.cn",
        },
        getFileId: getUploadId,
        getAuthFunction: getUploadToken,
        accept: "image/*",
      };
      this.handleClickUpload(option);
    },
    getClass() {
      let data = {
        shopId: this.chooseCompany.id,
      };
      getgoodsclassification(data).then((res) => {
        this.classList = res.data;
        // console.log(this.classList)
      });
    },
    handleSuccess(res) {
      // 获取富文本组件实例
      let quill = this.$refs.QuillEditor.quill;
      // 如果上传成功
      if (res) {
        // 获取光标所在位置
        let length = quill.getSelection().index;
        // 插入图片，res为服务器返回的图片链接地址
        console.log(res);
        quill.insertEmbed(length, "image", res.src);
        // 调整光标到最后
        quill.setSelection(length + 1);
      } else {
        // 提示信息，需引入Message
        Message.error("图片插入失败");
      }
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    go() {
      this.$router.push({
        path: "/main/storeUp/roots",
      });
    },
    addGoods() {
      let reContent = this.content.replace(
        /<img [^>]*src=['"]([^'"]+)[^>]*>/gi,
        function (match, reSrc) {
          var newImg = '<img src="' + reSrc + '" alt="" style="width:100%;" />';
          return newImg;
        }
      );
      let prices = Math.ceil(this.price * 100);
      let gardenPri = Math.ceil(this.gardenPrice * 100);
      let gardenOldPrice = Math.ceil(this.oldPrice * 100);
      let newImages = this.getImageSrc();
      let str = "";
      if (!newImages) return;
      if (!this.goodsName) {
        this.$message("商品姓名必不能为空");
        return;
      }
      if (!this.type) {
        this.$message("商品分类不能为空");
        return;
      }
      if (!gardenPri) {
        this.$message("普通价格不能为空或0");
        return;
      }
      if (!this.stacks) {
        this.$message("商品库存不能为空或0");
        return;
      }
      if (!this.costPrice) {
        this.$message("商品成本不能为空或0");
        return;
      }
      if (this.checkType.length) {
        this.checkType.forEach((item) => {
          str += item;
        });
        console.log(str);
      }
      if (!str.length) {
        this.$message("商品配送方式不能为空");
        return;
      }
      let data = {
        barCode: this.barCode,
        categoryId: "",
        content: reContent,
        employeePrice: gardenPri ? gardenPri : prices,
        oldPrice: gardenOldPrice,
        goodName: this.goodsName,
        goodLogos: newImages,
        logo: newImages[0] ? newImages[0] : "",
        maxSale: this.limit,
        mchId: this.chooseCompany.id,
        price: prices,
        status: this.status,
        stock: this.stacks,
        saleDesc: this.saleDesc,
        stockType: this.stockType,
        unit: this.specification,
        weight: this.weight,
        origin: this.product,
        lifeTime: this.lifeTime,
        type: this.type,
        warningRepertory: this.warningRepertory,
        deliveryType: str,
        costPrice: this.costPrice * 100, //成本价
      };
      if (this.status === -1) {
        let newDate = {
          endTime: new Date(this.endTime).getTime(), // 预售结束时间
          presalePrice: this.presalePrice * 100, //预售价格
          presaleMark: this.presaleMark, //预售说明
          minCount: this.minCount, // 最小预售量
          sendTime: this.preRedio == "0" ? this.date1 : this.date2,
          sendType: this.preRedio !== "0" ? "3" : this.sendType,
        };
        console.log(newDate);
        console.log(newDate.endTime);
        if (!this.presalePrice) {
          this.$message("商品预售价格必不能为空");
          return;
        }
        if (!newDate.endTime) {
          this.$message("商品预售结束时间必不能为空");
          return;
        }
        if (!newDate.minCount) {
          this.$message("商品最小预售量不能为空");
          return;
        }
        if (!newDate.sendTime) {
          this.$message("商品发送时间不能为空");
          return;
        }
        if (!newDate.sendType) {
          this.$message("商品发送类型不能为空");
          return;
        }
        if (!this.checkType.length) {
          this.$message("商品类型不能为空");
          return;
        }
        Object.assign(data, newDate);
        console.log(data);
        addPreGoods(data).then((res) => {
          console.log(res);
          if (res.data == "SUCCESS") {
            this.$message({
              type: "success",
              message: "设置预售成功!",
            });
            this.$router.push({
              path: "/main/preSellList",
            });
          }
        });
      } else {
        if (this.propertyName == "") {
          this.$message("请填写本商品属性");
          return;
        }
        this.relatedGoods.forEach((item) => {
          if (item.name == "") {
            this.$message("请填写关联商品属性");
            throw new Error("报错打断");
          } else if (typeof item.id == "undefined") {
            this.$message("有属性未关联商品");
            throw new Error("报错打断");
          }
        });
        data.linkDesc = this.propertyName;
        data.linkGoodsDesc = [];
        data.linkGoodsIds = [];
        this.relatedGoods.forEach((item) => {
          data.linkGoodsDesc.push(item.name);
          data.linkGoodsIds.push(item.id);
        });
        console.log(data);
        addGoods(data).then((res) => {
          console.log(res);
          if (res.code == 1) {
            this.$message({
              type: "success",
              message: "添加成功!",
            });
            this.$router.push({
              path: "/main/storeUp",
            });
          }
        });
      }
    },
    changezhou(event) {
      this.type = event;
    },
    changeStatu(event) {
      this.type = event;
      console.log(this.type);
    },
    // 获取商品分类
    _getGoodsCategory() {
      getGoodCategory().then((res) => {
        // console.log('Category', res);
        this.goodsCategory = res.data;
      });
    },
    //获取图片路径
    getImageSrc() {
      if (!this.imagesList.length) {
        this.$message("上传图片不能为空");
        return;
      } else {
        return this.imagesList;
      }
    },
    getData(res) {
      this.content = res;
      console.log(res);
    },
    delImages(index) {
      this.imagesList.splice(index, 1);
      // console.log(this.imagesList);
    },
    // 排序
    order(words) {
      var correlation = [],
        reorder = [];
      if (words === "") {
        return words;
      }
      words.forEach((item, index) => {
        let srcReg = /src=[\'\"]?([^\'\"]*)[\'\"]?/i;
        let src = item.match(srcReg);
        correlation[index] = {};
        correlation[index]["i"] = index;
        let number = "";
        let newStr = src[1];
        if (newStr.indexOf("/") > 0) {
          //如果包含有"/"号 从最后一个"/"号+1的位置开始截取字符串
          let filename = "";
          filename = newStr.substring(
            newStr.lastIndexOf("/") + 1,
            newStr.length
          );
          number = filename.substring(0, filename.indexOf("."));
        }
        correlation[index]["v"] = Number(number);
      });
      correlation.sort((a, b) => {
        return a.v - b.v;
      });
      correlation.forEach((item, index) => {
        reorder.push(words[item.i]);
      });
      return reorder.join("");
    },
    // 排序
    order2(words) {
      var correlation = [],
        reorder = [];
      if (words === "") {
        return words;
      }
      words.forEach((item, index) => {
        correlation[index] = {};
        correlation[index]["i"] = index;
        let number = "";
        if (item.indexOf("/") > 0) {
          //如果包含有"/"号 从最后一个"/"号+1的位置开始截取字符串
          let filename = "";
          filename = item.substring(item.lastIndexOf("/") + 1, item.length);
          number = filename.substring(0, filename.indexOf("."));
        }
        correlation[index]["v"] = Number(number);
      });
      correlation.sort((a, b) => {
        return a.v - b.v;
      });
      correlation.forEach((item, index) => {
        reorder.push(words[item.i]);
      });
      return reorder;
    },
    // 监听图片数组ID
    getImageFileId(introduce) {
      let totalStr = introduce; // introduce 是html代码
      let imgReg = /<img.*?(?:>|\/>)/gi; // 匹配图片中的img标签
      let srcReg = /src=[\'\"]?([^\'\"]*)[\'\"]?/i; // 匹配图片中的src
      let arr = totalStr.match(imgReg); // 筛选出所有的img
      // console.log('arr', arr);
      // let srcArr = [];
      // if (arr !== null) {
      //   for (let i = 0; i < arr.length; i++) {
      //     let src = arr[i].match(srcReg);
      //     // 获取图片地址
      //     srcArr.push(src[1]);
      //   }
      // }
      return arr;
    },
    handleCheckedCitiesChange(id) {
      if (this.checkList.length > 1) {
        this.checkList.splice(0, 1);
      }
      console.log(this.checkList);
      let [status] = this.checkList;
      this.status = status;
      console.log(this.status);
    },
    handleCheckedTypesChange(id) {
      // if(this.checkType.length > 1){
      //   this.checkType.splice(0,1)
      // }
      // console.log(this.checkType)
      // let [status] = this.checkType;
      this.checkType = this.checkType;
      console.log(this.checkType);
    },
    changeRedio(e) {
      console.log(e);
      this.preRedio = e;
    },
    addRelated() {
      //添加关联商品
      this.relatedGoods.push({ name: "", goodName: "" });
    },
    delRelated(i) {
      this.relatedGoods.splice(i, 1);
    },
    selectProducts(i) {
      this.selectIndex = i;
      this.centerDialogVisible = true;
      this.getGoodList();
    },
    getGoodList(page) {
      let mchId = this.chooseCompany.id;
      let data = {
        pageCount: 10,
        page: this.currentPage,
        goodName: this.searchValue,
        mchId: mchId,
      };
      if (page) {
        console.log(1);
        data.page = page;
      }
      getSeckillGood(data).then((res) => {
        let count = res.data.pop();
        if (typeof count != "undefined") {
          this.goodsCount = count.goodsCount;
        }
        this.tableData = res.data;
      });
    },
    reset() {
      this.searchValue = "";
      this.getGoodList();
    },
    addsgood(data) {
      let show = true;
      this.relatedGoods.forEach((item) => {
        if (item.id == data.goodId) {
          show = false;
        }
      });
      if (show) {
        this.relatedGoods[this.selectIndex].goodName = data.goodName;
        this.relatedGoods[this.selectIndex].id = data.goodId;
        console.log(this.relatedGoods);
        this.goodShow = true;
        this.centerDialogVisible = false;
      } else {
        this.$message("该商品已绑定");
      }
    },
    getValue(data){
      this.dialogVisible = false;
      this.relatedGoods.push({ name: "", goodName: data.goodsName, id:data.id});
      console.log(this.relatedGoods);
    },
    pageFn() {
      this.getGoodList();
    },
  },
};
</script>

<style lang="scss" scoped>
.clearfix:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
#addStore {
  width: 100%;
  padding: 0px 5px 5px 26px;
  box-sizing: border-box;
  .top {
    border-bottom: 1px solid #ebf1f3;
    height: 50px;
    i {
      float: left;
      height: 40px;
      line-height: 40px;
    }
    .msgTitle {
      float: left;
      height: 40px;
      line-height: 40px;
    }
    .button {
      float: right;
    }
  }
  .containertMain {
    // padding: 11px 83px 24px 78px;
    box-sizing: border-box;
    .Modular1 {
      .title {
        height: 50px;
        font-size: 16px;
        line-height: 50px;
        padding-left: 39px;

        .title_ {
          font-size: 14px;
          color: gray;
          margin-left: 10px;
        }
      }
      .content {
        padding: 11px 83px 24px 78px;
        .upload {
          /deep/ .el-form-item__content {
            display: flex;
            .imagesList {
              display: flex;
              margin: 0;
              padding-left: 0;
              .imagesItem {
                list-style-type: none;
                padding-right: 20px;
                position: relative;
                .img {
                  width: 85px;
                  height: 85px;
                  // border: 1px solid #f0f0f0;
                }
                .del {
                  width: 20px;
                  height: 20px;
                  position: absolute;
                  top: -10px;
                  right: 10px;
                }
              }
            }
          }
        }
      }
      // background: #999;
    }
    .Modular2 {
      margin-top: 20px;
      .title {
        height: 50px;
        font-size: 16px;
        line-height: 50px;
        padding-left: 39px;
      }
      .content {
        padding: 11px 83px 24px 78px;
      }
      .uploadimg {
        display: inline-block;
        text-align: center;
        line-height: 40px;
        padding: 5px 10px;
        cursor: pointer;
        color: #ccc;
        // margin-bottom: 8px;
      }

      // background: #999;
    }
  }
  .topleft {
    float: left;
    width: 100%;
    height: 100%;
    margin: 50px;
  }
  .text {
    display: inline-block;
    font-size: 32px;
    margin-left: 10px;
  }
  .inputItem {
    width: 100%;
  }
  .inputItem30 {
    width: 30%;
  }
  .inputItem70 {
    width: 160px;
  }
  .inputItem80 {
    width: 130px;
  }
  .picture {
    width: 85px;
    height: 85px;
    border: 1px solid #f0f0f0;
    padding: 20px;
    box-sizing: border-box;
    img {
      width: 100%;
    }
  }
}
.w-e-toolbar {
  border: 1px solid #dcdfe6;
}
.w-e-text-container {
  height: 300px !important; /*!important是重点，因为原div是行内样式设置的高度300px*/
  border: 1px solid #dcdfe6;
  border-top: none;
  z-index: 99 !important;
}
.red {
  color: red;
}
.textColor {
  color: #ccc;
}
.endDate {
  width: 100%;
}
.presellSet {
  .set {
    font-size: 14px;
    color: #606266;
    margin-bottom: 20px;
  }
  .blex1 {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #606266;
  }
  .blex2 {
    display: flex;
    align-items: center;
    margin-top: 20px;
    font-size: 14px;
    color: #606266;
  }
  .num {
    font-size: 14px;
    color: #606266;
    line-height: 40px;
    margin-left: 5px;
  }
  .endNum {
    font-size: 14px;
    color: #606266;
  }
}
.check {
  padding-bottom: 20px;
}
/deep/.w-e-toolbar .w-e-menu{
  z-index: 99 !important;
}
</style>


// WEBPACK FOOTER //
// src/pages/store/addStore.vue